import { createApp } from 'vue';
import App from './App.vue';
const app = createApp(App);
import 'core-js';
import 'regenerator-runtime/runtime';
import router from './router';
import store from './store';
import './assets/css/main.scss';
//全局註冊UI component
import UI from '@/library/index.js';

//全局註冊bootstrap icon
import 'bootstrap-icons/font/bootstrap-icons.css';

//全局註冊確定彈窗$confirm
import { useConfirm, useMessage } from '@/utils/confirm';
app.config.globalProperties.$confirm = useConfirm;
app.config.globalProperties.$message = useMessage;

import '@/utils/validate';
import '@/utils/datetime';
import '@/utils/text';

app.use(store).use(router).use(UI).mount('#app');
